// Initialize necessaries behaviours
document.addEventListener("turbolinks:load", () => {
  $(".navbar-sidenav").addClass("nav").removeClass("navbar-sidenav");
  $(".content-wrapper").removeClass("content-wrapper");
  //$(".nav-item").tooltip("disable");
  $(".fixed-top").removeClass("fixed-top");
  $(".fixed-nav").removeClass("fixed-nav");
});
